<template>
  <el-dialog title="请选择投保档次" :visible.sync="visible" class="my-dialog-template" width="600px" center>
    <el-table :data="gradeList" style="width: 100%" border tooltip-effect="dark" class="list-table" :loading="tableLoading">
      <el-table-column label="档次" min-width="120">
        <template slot-scope="{ row }">
          <span class="table-btn" @click="jump(row)">{{ row.grade }}</span>
        </template>
      </el-table-column>
      <el-table-column label="操作" min-width="120">
        <template slot-scope="scope">
          <el-button type="text" @click="operateFn(scope.row)" v-if="operate == 'copyLink'">复制链接</el-button>
          <el-button type="text" @click="operateFn(scope.row)" v-if="operate == 'jump'">在线录单</el-button>
        </template>
      </el-table-column>
    </el-table>
  </el-dialog>
</template>

<script>
export default {
  props: {},
  data: () => ({
    visible: false,
    tableLoading: false,
    operate: "",//当前弹窗操作 copyLink 复制链接 jump 跳转
    userinfo: {},
    url: "",
    gradeList: [],
    tableItem: {},
    columns: [
      {
        title: "档次",
        slot: "name",
        align: "center"
      },
      {
        title: "操作",
        slot: "action",
        align: "center",
      }
    ]
  }),
  created() {
    this.userinfo = this.$tools.getLocal("userinfo");
  },
  methods: {
    open(data, operate) {
      if (data.isSalePermission != 1) {//团险权限
        this.$message.error('暂无该产品销售权限，请联系您的销售支持');
        return;
      }
      this.tableItem = data;
      this.operate = operate;
      this.visible = true
      this.getGradeList();
    },
    async jump(data) {
      this.tableLoading = true;
      let url = await this.getLink(data);
      url = await this.transformLongUrl(url);
      this.tableLoading = false;
      window.open(url);
    },
    async operateFn(data) {
      this.tableLoading = true;
      let url = await this.getLink(data);
      url = await this.transformLongUrl(url);
      if (this.operate == 'copyLink') {
        this.$tools.copyUrl(url)
      } else if (this.operate == 'jump') {
        window.open(url);
      }
      this.tableLoading = false;
    },
    getLink(data) {
      return this.$http({
        type: "GET",
        url: "/insure/group/startPolicy",
        params: {
          productCode: this.tableItem.product.productNo,
          mechanCode: this.userinfo.code,
          grade: data.grade || "",
          type: 2,
          broker: this.operate == 'jump',
        },
      }).then((res) => {
        return res.data
      })
    },
    transformLongUrl(url) {
      return this.$http({
        url: "/bplatTool/transformLongUrl",
        type: "PUT",
        params: {
          url: url,
        },
      }).then((res) => {
        return res.data;
      });
    },
    getGradeList() {
      this.$http({
        type: "GET",
        url: "/insure/group/productGrades",
        params: {
          productCode: this.tableItem.product.productNo,
          mechanCode: this.userinfo.code,
        },
      }).then((res) => {
        this.gradeList = res.data;
      });
    }
  },
}
</script>

<style lang='scss' scoped>
.list-table {
  margin-bottom: 20px;
}
</style>